import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { InstructorCard } from '../instructor-card/instructor-card.react-component';
import styles from './instructor-list.module.scss';
import { useI18n } from '@udemy-v2/i18n';
import classNames from 'classnames';
import { useInstructorDetails } from '@/lib/hooks/use-instructor-details';

/**
 * Renders a list of InstructorCard components for each instructor
 *
 * @example
 * ```jsx
 * <InstructorList instructors={course.instructors} />
 * ```
 */
export const InstructorList = () => {
  const $ = _c(11);
  const {
    gettext
  } = useI18n();
  const instructorDetails = useInstructorDetails();
  if (!instructorDetails?.length) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classNames("ud-heading-xl", styles["instructor-list-container"]);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== gettext || $[2] !== instructorDetails.length) {
    t1 = instructorDetails.length > 1 ? gettext("Instructors") : gettext("Instructor");
    $[1] = gettext;
    $[2] = instructorDetails.length;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== instructorDetails) {
    t2 = instructorDetails.map(_temp);
    $[4] = instructorDetails;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className={styles["instructor-list-card"]}>{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className={t0}>{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(instructor, index) {
  if (!instructor.url) {
    return null;
  }
  return <InstructorCard key={`${instructor.url}-${instructor.id}`} instructor={instructor} index={index} />;
}